(function (window) {
  /**
   * BatchGeoCluster is a small, no-op, no-method component that when enabled
   * will turn on/off clusters on page load and will listen for Cluster
   * enabled events from BatchGeoStore and cache that setting in localStorage.
   * @constructor
   */
  let clusterBoundsListener;

  window.BatchGeoCluster = async function () {
    var clusterPersist = new BatchGeoPersistence({ key: "Cluster" });
    var state = BatchGeoStore.getState().App;
    const markerDrawer = window.batchGeoGoogleMapsMarker.MarkerDrawer;
    const map = window.batchGeoGoogleMapsManager.getMap();
    var cluster = clusterPersist.fetch(state.mapId);
    var defaultCluster = window.per.clustering_cb_status;

    // Set clusterEnabled to a var so we can alter it later
    var clusterEnabled = defaultCluster;

    // If localStorage is undefined then use the map's default, but if
    // not then use the option the user had. Set this _before_ the listener
    // or else if a user hits the map it'll cache clustering_cb_status. Then
    // if the map owner changes that setting it wont be reflected to the
    // user (which will be them first) and it'll seem like it's not updating
    if (state.isMap && !BatchGeo.iframeDetect()) {
      clusterEnabled = cluster !== undefined ? cluster : defaultCluster;
    }

    if (state.cluster) {
      clusterEnabled = !!state.cluster;
    }

    // For now there is no use case of a method to enable/disable this so
    // once you call BatchGeoCluster it's on forever. If there is eventually
    // a need for dynamic enable/disabling adding a enable() and disable()
    // method probably makes sense that will add/remove this listener.
    BatchGeoStore.addListener("Cluster", "enabled", function (newState) {
      if (state.isMap) {
        clusterPersist.set(state.mapId, newState.enabled);
      }

      if (newState.enabled) {
        clusterBoundsListener = google.maps.event.addListener(
          map,
          "bounds_changed",
          () => {
            markerDrawer.checkLabels();
          },
        );
      } else {
        google.maps.event.removeListener(clusterBoundsListener);
      }
      markerDrawer.checkLabels();
    });

    BatchGeoStore.dispatch({
      type: "CLUSTER_SET_ENABLED",
      enabled: clusterEnabled,
    });
  };
})(window);
